<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('materialmedium_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-format-color-fill</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-materialmedium-show">
      <v-img
        class = "ma-2"
        max-height="250"
        max-width="250"
        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          v-if="userHasAccess('materialmedium_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.material.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td></td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';
import ImageForm from '../../components/ImageForm.vue';
const servicePrefix = 'MaterialMedium';

export default {
  name: 'MaterialMediumShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageForm,
  },
  data: () => ({
    filter: '250x250',
  }),
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('materialmedium', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('materialmedium', ['find'])
  },
  methods: {
    ...mapActions('materialmedium', {
      deleteItem: 'del',
      reset: 'reset',
      update: 'update',
      retrieve: 'load'
    })
  }
};
</script>
